import { Box } from "@mui/material";
import LoadingSpinner from "./LoadingSpinner";

const LoadingScreen = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <LoadingSpinner />
    </Box>
  );
};

export default LoadingScreen;
